import React from "react";
import { Box, Button, Paper, Typography } from "@mui/material";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "config";

export default function NotFound({
    title = "Employee Not Found",
    description = "The employee record you are looking for doesn't exist, may have been removed, or the URL might be incorrect.",
    backPath = ROUTES.EMPLOYEES,
    backText = "Back to Employees"
}) {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "60vh",
                p: 3
            }}
        >
            <Paper
                variant="outlined"
                sx={{
                    maxWidth: 480,
                    width: "100%",
                    p: 4,
                    textAlign: "center",
                    borderRadius: 3,
                    borderColor: "#E2E8F0",
                    backgroundColor: "#FFFFFF",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.03)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center"
                }}
            >
                {/* Subtle Terracotta/Red Icon Container */}
                <Box
                    sx={{
                        width: 64,
                        height: 64,
                        borderRadius: "50%",
                        backgroundColor: "rgba(194, 89, 83, 0.08)",
                        color: "#C25953",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 2.5
                    }}
                >
                    <PersonOffOutlinedIcon sx={{ fontSize: 32 }} />
                </Box>

                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 700,
                        color: "#2D3748",
                        mb: 1
                    }}
                >
                    {title}
                </Typography>

                <Typography
                    variant="body2"
                    sx={{
                        color: "#64748B",
                        mb: 3,
                        lineHeight: 1.6
                    }}
                >
                    {description}
                </Typography>

                <Button
                    variant="contained"
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate(backPath)}
                    sx={{ textTransform: "none", px: 3 }}
                >
                    {backText}
                </Button>
            </Paper>
        </Box>
    );
}
